var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PaginationLabel"},[(_vm.pagination.itemCount)?[_vm._v(_vm._s(_vm.intervalMin)+"-"+_vm._s(_vm.intervalMax))]:_vm._e(),_vm._v(" "+_vm._s(_vm.$tc("pagination.label", _vm.pagination.itemCount))+" ")],2)}
var staticRenderFns = []

export { render, staticRenderFns }